// source: sync.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.CSync', null, global);
goog.exportSymbol('proto.proto.CSync.CameraFocusNotify', null, global);
goog.exportSymbol('proto.proto.CSync.CameraZoomNotify', null, global);
goog.exportSymbol('proto.proto.CSync.DrawClearNotify', null, global);
goog.exportSymbol('proto.proto.CSync.DrawDataArrayNotify', null, global);
goog.exportSymbol('proto.proto.CSync.DrawDataNotify', null, global);
goog.exportSymbol('proto.proto.CSync.DrawDataWebNotify', null, global);
goog.exportSymbol('proto.proto.CSync.DrawRevokeNotify', null, global);
goog.exportSymbol('proto.proto.CSync.FreezeNotify', null, global);
goog.exportSymbol('proto.proto.CSync.Notify', null, global);
goog.exportSymbol('proto.proto.CSync.PortalDataNotify', null, global);
goog.exportSymbol('proto.proto.CSync.RemoteControl', null, global);
goog.exportSymbol('proto.proto.CSync.SData', null, global);
goog.exportSymbol('proto.proto.CSync.SlamMarkNotify', null, global);
goog.exportSymbol('proto.proto.CSync.SyncMarkNotify', null, global);
goog.exportSymbol('proto.proto.CSync.TrackDataNofity', null, global);
goog.exportSymbol('proto.proto.CSync.WebData', null, global);
goog.exportSymbol('proto.proto.CSync.WhiteBoardImageNotify', null, global);
goog.exportSymbol('proto.proto.ChannelMarkData', null, global);
goog.exportSymbol('proto.proto.ChannelMarkData.FreezeData', null, global);
goog.exportSymbol('proto.proto.ChannelMarkData.MarkData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.displayName = 'proto.proto.CSync';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.SData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.SData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.SData.displayName = 'proto.proto.CSync.SData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.Notify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.CSync.Notify.repeatedFields_, null);
};
goog.inherits(proto.proto.CSync.Notify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.Notify.displayName = 'proto.proto.CSync.Notify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.RemoteControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.RemoteControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.RemoteControl.displayName = 'proto.proto.CSync.RemoteControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.FreezeNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.FreezeNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.FreezeNotify.displayName = 'proto.proto.CSync.FreezeNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.WebData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.WebData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.WebData.displayName = 'proto.proto.CSync.WebData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.SyncMarkNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.SyncMarkNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.SyncMarkNotify.displayName = 'proto.proto.CSync.SyncMarkNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.SlamMarkNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.SlamMarkNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.SlamMarkNotify.displayName = 'proto.proto.CSync.SlamMarkNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.DrawDataWebNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.CSync.DrawDataWebNotify.repeatedFields_, null);
};
goog.inherits(proto.proto.CSync.DrawDataWebNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.DrawDataWebNotify.displayName = 'proto.proto.CSync.DrawDataWebNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.DrawDataArrayNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.CSync.DrawDataArrayNotify.repeatedFields_, null);
};
goog.inherits(proto.proto.CSync.DrawDataArrayNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.DrawDataArrayNotify.displayName = 'proto.proto.CSync.DrawDataArrayNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.DrawDataNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.DrawDataNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.DrawDataNotify.displayName = 'proto.proto.CSync.DrawDataNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.PortalDataNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.PortalDataNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.PortalDataNotify.displayName = 'proto.proto.CSync.PortalDataNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.TrackDataNofity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.TrackDataNofity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.TrackDataNofity.displayName = 'proto.proto.CSync.TrackDataNofity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.DrawRevokeNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.DrawRevokeNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.DrawRevokeNotify.displayName = 'proto.proto.CSync.DrawRevokeNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.DrawClearNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.DrawClearNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.DrawClearNotify.displayName = 'proto.proto.CSync.DrawClearNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.WhiteBoardImageNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.WhiteBoardImageNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.WhiteBoardImageNotify.displayName = 'proto.proto.CSync.WhiteBoardImageNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.CameraZoomNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.CameraZoomNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.CameraZoomNotify.displayName = 'proto.proto.CSync.CameraZoomNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CSync.CameraFocusNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CSync.CameraFocusNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CSync.CameraFocusNotify.displayName = 'proto.proto.CSync.CameraFocusNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChannelMarkData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChannelMarkData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ChannelMarkData.displayName = 'proto.proto.ChannelMarkData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChannelMarkData.FreezeData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChannelMarkData.FreezeData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ChannelMarkData.FreezeData.displayName = 'proto.proto.ChannelMarkData.FreezeData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChannelMarkData.MarkData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChannelMarkData.MarkData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ChannelMarkData.MarkData.displayName = 'proto.proto.ChannelMarkData.MarkData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync}
 */
proto.proto.CSync.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync;
  return proto.proto.CSync.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync}
 */
proto.proto.CSync.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.SData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.SData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.SData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.SData.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.SData}
 */
proto.proto.CSync.SData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.SData;
  return proto.proto.CSync.SData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.SData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.SData}
 */
proto.proto.CSync.SData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.SData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.SData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.SData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.SData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional uint32 Type = 1;
 * @return {number}
 */
proto.proto.CSync.SData.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SData} returns this
 */
proto.proto.CSync.SData.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bytes Data = 2;
 * @return {string}
 */
proto.proto.CSync.SData.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes Data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.proto.CSync.SData.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.proto.CSync.SData.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.proto.CSync.SData} returns this
 */
proto.proto.CSync.SData.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.CSync.Notify.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.Notify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.Notify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.Notify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.Notify.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    msgsList: jspb.Message.toObjectList(msg.getMsgsList(),
    proto.proto.CSync.SData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.Notify}
 */
proto.proto.CSync.Notify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.Notify;
  return proto.proto.CSync.Notify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.Notify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.Notify}
 */
proto.proto.CSync.Notify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = new proto.proto.CSync.SData;
      reader.readMessage(value,proto.proto.CSync.SData.deserializeBinaryFromReader);
      msg.addMsgs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.Notify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.Notify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.Notify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.Notify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsgsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.CSync.SData.serializeBinaryToWriter
    );
  }
};


/**
 * optional string UserID = 1;
 * @return {string}
 */
proto.proto.CSync.Notify.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.Notify} returns this
 */
proto.proto.CSync.Notify.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SData Msgs = 2;
 * @return {!Array<!proto.proto.CSync.SData>}
 */
proto.proto.CSync.Notify.prototype.getMsgsList = function() {
  return /** @type{!Array<!proto.proto.CSync.SData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.CSync.SData, 2));
};


/**
 * @param {!Array<!proto.proto.CSync.SData>} value
 * @return {!proto.proto.CSync.Notify} returns this
*/
proto.proto.CSync.Notify.prototype.setMsgsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.CSync.SData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.CSync.SData}
 */
proto.proto.CSync.Notify.prototype.addMsgs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.CSync.SData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.CSync.Notify} returns this
 */
proto.proto.CSync.Notify.prototype.clearMsgsList = function() {
  return this.setMsgsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.RemoteControl.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.RemoteControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.RemoteControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.RemoteControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    controleduserid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    onoff: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    extra: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.RemoteControl}
 */
proto.proto.CSync.RemoteControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.RemoteControl;
  return proto.proto.CSync.RemoteControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.RemoteControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.RemoteControl}
 */
proto.proto.CSync.RemoteControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setControleduserid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnoff(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtra(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.RemoteControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.RemoteControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.RemoteControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.RemoteControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getControleduserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOnoff();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getExtra();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional uint32 Type = 1;
 * @return {number}
 */
proto.proto.CSync.RemoteControl.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.RemoteControl} returns this
 */
proto.proto.CSync.RemoteControl.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ControlUserId = 2;
 * @return {string}
 */
proto.proto.CSync.RemoteControl.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.RemoteControl} returns this
 */
proto.proto.CSync.RemoteControl.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ControledUserId = 3;
 * @return {string}
 */
proto.proto.CSync.RemoteControl.prototype.getControleduserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.RemoteControl} returns this
 */
proto.proto.CSync.RemoteControl.prototype.setControleduserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool OnOff = 4;
 * @return {boolean}
 */
proto.proto.CSync.RemoteControl.prototype.getOnoff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.CSync.RemoteControl} returns this
 */
proto.proto.CSync.RemoteControl.prototype.setOnoff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string Extra = 5;
 * @return {string}
 */
proto.proto.CSync.RemoteControl.prototype.getExtra = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.RemoteControl} returns this
 */
proto.proto.CSync.RemoteControl.prototype.setExtra = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.FreezeNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.FreezeNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.FreezeNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.FreezeNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.FreezeNotify}
 */
proto.proto.CSync.FreezeNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.FreezeNotify;
  return proto.proto.CSync.FreezeNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.FreezeNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.FreezeNotify}
 */
proto.proto.CSync.FreezeNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.FreezeNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.FreezeNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.FreezeNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.FreezeNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 TimeStamp = 1;
 * @return {number}
 */
proto.proto.CSync.FreezeNotify.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.FreezeNotify} returns this
 */
proto.proto.CSync.FreezeNotify.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.WebData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.WebData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.WebData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.WebData.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.WebData}
 */
proto.proto.CSync.WebData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.WebData;
  return proto.proto.CSync.WebData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.WebData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.WebData}
 */
proto.proto.CSync.WebData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.WebData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.WebData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.WebData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.WebData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional uint32 Type = 1;
 * @return {number}
 */
proto.proto.CSync.WebData.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.WebData} returns this
 */
proto.proto.CSync.WebData.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bytes Data = 2;
 * @return {string}
 */
proto.proto.CSync.WebData.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes Data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.proto.CSync.WebData.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.proto.CSync.WebData.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.proto.CSync.WebData} returns this
 */
proto.proto.CSync.WebData.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.SyncMarkNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.SyncMarkNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.SyncMarkNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.SyncMarkNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    colour: jspb.Message.getFieldWithDefault(msg, 1, 0),
    posx: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    posy: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    becontroluserid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    size: jspb.Message.getFieldWithDefault(msg, 6, 0),
    type: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.SyncMarkNotify}
 */
proto.proto.CSync.SyncMarkNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.SyncMarkNotify;
  return proto.proto.CSync.SyncMarkNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.SyncMarkNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.SyncMarkNotify}
 */
proto.proto.CSync.SyncMarkNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColour(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPosx(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPosy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBecontroluserid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSize(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.SyncMarkNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.SyncMarkNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.SyncMarkNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.SyncMarkNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColour();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPosx();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getPosy();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBecontroluserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional int32 Colour = 1;
 * @return {number}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getColour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setColour = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float PosX = 2;
 * @return {number}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getPosx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setPosx = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float PosY = 3;
 * @return {number}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getPosy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setPosy = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string ControlUserId = 4;
 * @return {string}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string BeControlUserId = 5;
 * @return {string}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getBecontroluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setBecontroluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 Size = 6;
 * @return {number}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 Type = 7;
 * @return {number}
 */
proto.proto.CSync.SyncMarkNotify.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SyncMarkNotify} returns this
 */
proto.proto.CSync.SyncMarkNotify.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.SlamMarkNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.SlamMarkNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.SlamMarkNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.SlamMarkNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    colour: jspb.Message.getFieldWithDefault(msg, 1, 0),
    posx: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    posy: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    becontroluserid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    radius: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    border: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    textureindex: jspb.Message.getFieldWithDefault(msg, 8, 0),
    type: jspb.Message.getFieldWithDefault(msg, 9, 0),
    action: jspb.Message.getFieldWithDefault(msg, 10, 0),
    tag: jspb.Message.getFieldWithDefault(msg, 11, ""),
    imgpath: jspb.Message.getFieldWithDefault(msg, 12, ""),
    texturerotation: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    texturewidth: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    textureheight: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.SlamMarkNotify}
 */
proto.proto.CSync.SlamMarkNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.SlamMarkNotify;
  return proto.proto.CSync.SlamMarkNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.SlamMarkNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.SlamMarkNotify}
 */
proto.proto.CSync.SlamMarkNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColour(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPosx(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPosy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBecontroluserid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRadius(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBorder(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTextureindex(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAction(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgpath(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTexturerotation(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTexturewidth(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTextureheight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.SlamMarkNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.SlamMarkNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.SlamMarkNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.SlamMarkNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColour();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPosx();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getPosy();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBecontroluserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRadius();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getBorder();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getTextureindex();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getAction();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getImgpath();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTexturerotation();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getTexturewidth();
  if (f !== 0.0) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = message.getTextureheight();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
};


/**
 * optional int32 Colour = 1;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getColour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setColour = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float PosX = 2;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getPosx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setPosx = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float PosY = 3;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getPosy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setPosy = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string ControlUserId = 4;
 * @return {string}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string BeControlUserId = 5;
 * @return {string}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getBecontroluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setBecontroluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional float Radius = 6;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float Border = 7;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getBorder = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setBorder = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint32 TextureIndex = 8;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getTextureindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setTextureindex = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 Type = 9;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 Action = 10;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getAction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setAction = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string Tag = 11;
 * @return {string}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setTag = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string ImgPath = 12;
 * @return {string}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getImgpath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setImgpath = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional float TextureRotation = 13;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getTexturerotation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setTexturerotation = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional float TextureWidth = 14;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getTexturewidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setTexturewidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional float TextureHeight = 15;
 * @return {number}
 */
proto.proto.CSync.SlamMarkNotify.prototype.getTextureheight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.SlamMarkNotify} returns this
 */
proto.proto.CSync.SlamMarkNotify.prototype.setTextureheight = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.CSync.DrawDataWebNotify.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.DrawDataWebNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.DrawDataWebNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawDataWebNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    posxList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f,
    posyList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 2)) == null ? undefined : f,
    colour: jspb.Message.getFieldWithDefault(msg, 3, 0),
    number: jspb.Message.getFieldWithDefault(msg, 4, 0),
    width: jspb.Message.getFieldWithDefault(msg, 5, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    starttime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.DrawDataWebNotify}
 */
proto.proto.CSync.DrawDataWebNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.DrawDataWebNotify;
  return proto.proto.CSync.DrawDataWebNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.DrawDataWebNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.DrawDataWebNotify}
 */
proto.proto.CSync.DrawDataWebNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPosx(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPosy(values[i]);
      }
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColour(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWidth(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setStarttime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEndtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.DrawDataWebNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.DrawDataWebNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawDataWebNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosxList();
  if (f.length > 0) {
    writer.writePackedFloat(
      1,
      f
    );
  }
  f = message.getPosyList();
  if (f.length > 0) {
    writer.writePackedFloat(
      2,
      f
    );
  }
  f = message.getColour();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNumber();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
};


/**
 * repeated float PosX = 1;
 * @return {!Array<number>}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getPosxList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setPosxList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.addPosx = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.clearPosxList = function() {
  return this.setPosxList([]);
};


/**
 * repeated float PosY = 2;
 * @return {!Array<number>}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getPosyList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setPosyList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.addPosy = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.clearPosyList = function() {
  return this.setPosyList([]);
};


/**
 * optional int32 Colour = 3;
 * @return {number}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getColour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setColour = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 Number = 4;
 * @return {number}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 Width = 5;
 * @return {number}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string ControlUserId = 6;
 * @return {string}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 StartTime = 7;
 * @return {number}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getStarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setStarttime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 EndTime = 8;
 * @return {number}
 */
proto.proto.CSync.DrawDataWebNotify.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataWebNotify} returns this
 */
proto.proto.CSync.DrawDataWebNotify.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.CSync.DrawDataArrayNotify.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.DrawDataArrayNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.DrawDataArrayNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.DrawDataArrayNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawDataArrayNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    drawdatasList: jspb.Message.toObjectList(msg.getDrawdatasList(),
    proto.proto.CSync.DrawDataWebNotify.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.DrawDataArrayNotify}
 */
proto.proto.CSync.DrawDataArrayNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.DrawDataArrayNotify;
  return proto.proto.CSync.DrawDataArrayNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.DrawDataArrayNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.DrawDataArrayNotify}
 */
proto.proto.CSync.DrawDataArrayNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.CSync.DrawDataWebNotify;
      reader.readMessage(value,proto.proto.CSync.DrawDataWebNotify.deserializeBinaryFromReader);
      msg.addDrawdatas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.DrawDataArrayNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.DrawDataArrayNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.DrawDataArrayNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawDataArrayNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrawdatasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.CSync.DrawDataWebNotify.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DrawDataWebNotify DrawDatas = 1;
 * @return {!Array<!proto.proto.CSync.DrawDataWebNotify>}
 */
proto.proto.CSync.DrawDataArrayNotify.prototype.getDrawdatasList = function() {
  return /** @type{!Array<!proto.proto.CSync.DrawDataWebNotify>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.CSync.DrawDataWebNotify, 1));
};


/**
 * @param {!Array<!proto.proto.CSync.DrawDataWebNotify>} value
 * @return {!proto.proto.CSync.DrawDataArrayNotify} returns this
*/
proto.proto.CSync.DrawDataArrayNotify.prototype.setDrawdatasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.CSync.DrawDataWebNotify=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.CSync.DrawDataWebNotify}
 */
proto.proto.CSync.DrawDataArrayNotify.prototype.addDrawdatas = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.CSync.DrawDataWebNotify, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.CSync.DrawDataArrayNotify} returns this
 */
proto.proto.CSync.DrawDataArrayNotify.prototype.clearDrawdatasList = function() {
  return this.setDrawdatasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.DrawDataNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.DrawDataNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.DrawDataNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawDataNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    posx: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    posy: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    colour: jspb.Message.getFieldWithDefault(msg, 3, 0),
    number: jspb.Message.getFieldWithDefault(msg, 4, 0),
    width: jspb.Message.getFieldWithDefault(msg, 5, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.DrawDataNotify}
 */
proto.proto.CSync.DrawDataNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.DrawDataNotify;
  return proto.proto.CSync.DrawDataNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.DrawDataNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.DrawDataNotify}
 */
proto.proto.CSync.DrawDataNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPosx(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPosy(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColour(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWidth(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.DrawDataNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.DrawDataNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.DrawDataNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawDataNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosx();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getPosy();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getColour();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNumber();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional float PosX = 1;
 * @return {number}
 */
proto.proto.CSync.DrawDataNotify.prototype.getPosx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataNotify} returns this
 */
proto.proto.CSync.DrawDataNotify.prototype.setPosx = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float PosY = 2;
 * @return {number}
 */
proto.proto.CSync.DrawDataNotify.prototype.getPosy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataNotify} returns this
 */
proto.proto.CSync.DrawDataNotify.prototype.setPosy = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 Colour = 3;
 * @return {number}
 */
proto.proto.CSync.DrawDataNotify.prototype.getColour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataNotify} returns this
 */
proto.proto.CSync.DrawDataNotify.prototype.setColour = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 Number = 4;
 * @return {number}
 */
proto.proto.CSync.DrawDataNotify.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataNotify} returns this
 */
proto.proto.CSync.DrawDataNotify.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 Width = 5;
 * @return {number}
 */
proto.proto.CSync.DrawDataNotify.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawDataNotify} returns this
 */
proto.proto.CSync.DrawDataNotify.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string ControlUserId = 6;
 * @return {string}
 */
proto.proto.CSync.DrawDataNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.DrawDataNotify} returns this
 */
proto.proto.CSync.DrawDataNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.PortalDataNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.PortalDataNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.PortalDataNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.PortalDataNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    data: msg.getData_asB64(),
    controluserid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.PortalDataNotify}
 */
proto.proto.CSync.PortalDataNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.PortalDataNotify;
  return proto.proto.CSync.PortalDataNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.PortalDataNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.PortalDataNotify}
 */
proto.proto.CSync.PortalDataNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.PortalDataNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.PortalDataNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.PortalDataNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.PortalDataNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint32 Type = 1;
 * @return {number}
 */
proto.proto.CSync.PortalDataNotify.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.PortalDataNotify} returns this
 */
proto.proto.CSync.PortalDataNotify.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bytes Data = 2;
 * @return {string}
 */
proto.proto.CSync.PortalDataNotify.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes Data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.proto.CSync.PortalDataNotify.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.proto.CSync.PortalDataNotify.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.proto.CSync.PortalDataNotify} returns this
 */
proto.proto.CSync.PortalDataNotify.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional string ControlUserId = 3;
 * @return {string}
 */
proto.proto.CSync.PortalDataNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.PortalDataNotify} returns this
 */
proto.proto.CSync.PortalDataNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.TrackDataNofity.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.TrackDataNofity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.TrackDataNofity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.TrackDataNofity.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    width: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    height: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    imgwidth: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    imgheight: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    colour: jspb.Message.getFieldWithDefault(msg, 7, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.TrackDataNofity}
 */
proto.proto.CSync.TrackDataNofity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.TrackDataNofity;
  return proto.proto.CSync.TrackDataNofity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.TrackDataNofity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.TrackDataNofity}
 */
proto.proto.CSync.TrackDataNofity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setImgwidth(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setImgheight(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColour(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.TrackDataNofity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.TrackDataNofity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.TrackDataNofity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.TrackDataNofity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getImgwidth();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getImgheight();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getColour();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float width = 3;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float height = 4;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float imgWidth = 5;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getImgwidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setImgwidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float imgHeight = 6;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getImgheight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setImgheight = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 Colour = 7;
 * @return {number}
 */
proto.proto.CSync.TrackDataNofity.prototype.getColour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setColour = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string ControlUserId = 8;
 * @return {string}
 */
proto.proto.CSync.TrackDataNofity.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.TrackDataNofity} returns this
 */
proto.proto.CSync.TrackDataNofity.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.DrawRevokeNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.DrawRevokeNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.DrawRevokeNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawRevokeNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    number: jspb.Message.getFieldWithDefault(msg, 1, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.DrawRevokeNotify}
 */
proto.proto.CSync.DrawRevokeNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.DrawRevokeNotify;
  return proto.proto.CSync.DrawRevokeNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.DrawRevokeNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.DrawRevokeNotify}
 */
proto.proto.CSync.DrawRevokeNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.DrawRevokeNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.DrawRevokeNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.DrawRevokeNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawRevokeNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumber();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 Number = 1;
 * @return {number}
 */
proto.proto.CSync.DrawRevokeNotify.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.DrawRevokeNotify} returns this
 */
proto.proto.CSync.DrawRevokeNotify.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ControlUserId = 2;
 * @return {string}
 */
proto.proto.CSync.DrawRevokeNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.DrawRevokeNotify} returns this
 */
proto.proto.CSync.DrawRevokeNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.DrawClearNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.DrawClearNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.DrawClearNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawClearNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    controluserid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.DrawClearNotify}
 */
proto.proto.CSync.DrawClearNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.DrawClearNotify;
  return proto.proto.CSync.DrawClearNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.DrawClearNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.DrawClearNotify}
 */
proto.proto.CSync.DrawClearNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.DrawClearNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.DrawClearNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.DrawClearNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.DrawClearNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ControlUserId = 1;
 * @return {string}
 */
proto.proto.CSync.DrawClearNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.DrawClearNotify} returns this
 */
proto.proto.CSync.DrawClearNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.WhiteBoardImageNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.WhiteBoardImageNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.WhiteBoardImageNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageurl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imagekcpkey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    controluserid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.WhiteBoardImageNotify}
 */
proto.proto.CSync.WhiteBoardImageNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.WhiteBoardImageNotify;
  return proto.proto.CSync.WhiteBoardImageNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.WhiteBoardImageNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.WhiteBoardImageNotify}
 */
proto.proto.CSync.WhiteBoardImageNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageurl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImagekcpkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.WhiteBoardImageNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.WhiteBoardImageNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.WhiteBoardImageNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageurl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImagekcpkey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string ImageUrl = 1;
 * @return {string}
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.getImageurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.WhiteBoardImageNotify} returns this
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.setImageurl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ImageKcpKey = 2;
 * @return {string}
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.getImagekcpkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.WhiteBoardImageNotify} returns this
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.setImagekcpkey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ControlUserId = 3;
 * @return {string}
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.WhiteBoardImageNotify} returns this
 */
proto.proto.CSync.WhiteBoardImageNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.CameraZoomNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.CameraZoomNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.CameraZoomNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.CameraZoomNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    zoom: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    touserid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    controluserid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.CameraZoomNotify}
 */
proto.proto.CSync.CameraZoomNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.CameraZoomNotify;
  return proto.proto.CSync.CameraZoomNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.CameraZoomNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.CameraZoomNotify}
 */
proto.proto.CSync.CameraZoomNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZoom(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTouserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.CameraZoomNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.CameraZoomNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.CameraZoomNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.CameraZoomNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZoom();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getTouserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional float zoom = 1;
 * @return {number}
 */
proto.proto.CSync.CameraZoomNotify.prototype.getZoom = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.CameraZoomNotify} returns this
 */
proto.proto.CSync.CameraZoomNotify.prototype.setZoom = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string ToUserId = 2;
 * @return {string}
 */
proto.proto.CSync.CameraZoomNotify.prototype.getTouserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.CameraZoomNotify} returns this
 */
proto.proto.CSync.CameraZoomNotify.prototype.setTouserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ControlUserId = 3;
 * @return {string}
 */
proto.proto.CSync.CameraZoomNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.CameraZoomNotify} returns this
 */
proto.proto.CSync.CameraZoomNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CSync.CameraFocusNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CSync.CameraFocusNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CSync.CameraFocusNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.CameraFocusNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    centerx: jspb.Message.getFieldWithDefault(msg, 1, 0),
    centery: jspb.Message.getFieldWithDefault(msg, 2, 0),
    touserid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    controluserid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CSync.CameraFocusNotify}
 */
proto.proto.CSync.CameraFocusNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CSync.CameraFocusNotify;
  return proto.proto.CSync.CameraFocusNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CSync.CameraFocusNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CSync.CameraFocusNotify}
 */
proto.proto.CSync.CameraFocusNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCenterx(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCentery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTouserid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CSync.CameraFocusNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CSync.CameraFocusNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CSync.CameraFocusNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CSync.CameraFocusNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCenterx();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCentery();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTouserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 centerX = 1;
 * @return {number}
 */
proto.proto.CSync.CameraFocusNotify.prototype.getCenterx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.CameraFocusNotify} returns this
 */
proto.proto.CSync.CameraFocusNotify.prototype.setCenterx = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 centerY = 2;
 * @return {number}
 */
proto.proto.CSync.CameraFocusNotify.prototype.getCentery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CSync.CameraFocusNotify} returns this
 */
proto.proto.CSync.CameraFocusNotify.prototype.setCentery = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ToUserId = 3;
 * @return {string}
 */
proto.proto.CSync.CameraFocusNotify.prototype.getTouserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.CameraFocusNotify} returns this
 */
proto.proto.CSync.CameraFocusNotify.prototype.setTouserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ControlUserId = 4;
 * @return {string}
 */
proto.proto.CSync.CameraFocusNotify.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CSync.CameraFocusNotify} returns this
 */
proto.proto.CSync.CameraFocusNotify.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChannelMarkData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChannelMarkData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChannelMarkData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelMarkData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChannelMarkData}
 */
proto.proto.ChannelMarkData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChannelMarkData;
  return proto.proto.ChannelMarkData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChannelMarkData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChannelMarkData}
 */
proto.proto.ChannelMarkData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChannelMarkData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChannelMarkData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChannelMarkData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelMarkData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChannelMarkData.FreezeData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChannelMarkData.FreezeData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelMarkData.FreezeData.toObject = function(includeInstance, msg) {
  var f, obj = {
    freezetype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    freezeid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    freezedid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
    kcpkey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    url: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChannelMarkData.FreezeData}
 */
proto.proto.ChannelMarkData.FreezeData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChannelMarkData.FreezeData;
  return proto.proto.ChannelMarkData.FreezeData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChannelMarkData.FreezeData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChannelMarkData.FreezeData}
 */
proto.proto.ChannelMarkData.FreezeData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFreezetype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezedid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setKcpkey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChannelMarkData.FreezeData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChannelMarkData.FreezeData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelMarkData.FreezeData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezetype();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFreezeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFreezedid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getKcpkey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint32 freezeType = 1;
 * @return {number}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.getFreezetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChannelMarkData.FreezeData} returns this
 */
proto.proto.ChannelMarkData.FreezeData.prototype.setFreezetype = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string freezeId = 2;
 * @return {string}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.getFreezeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChannelMarkData.FreezeData} returns this
 */
proto.proto.ChannelMarkData.FreezeData.prototype.setFreezeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string freezedId = 3;
 * @return {string}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.getFreezedid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChannelMarkData.FreezeData} returns this
 */
proto.proto.ChannelMarkData.FreezeData.prototype.setFreezedid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 timeStamp = 4;
 * @return {number}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChannelMarkData.FreezeData} returns this
 */
proto.proto.ChannelMarkData.FreezeData.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string kcpKey = 5;
 * @return {string}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.getKcpkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChannelMarkData.FreezeData} returns this
 */
proto.proto.ChannelMarkData.FreezeData.prototype.setKcpkey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string url = 6;
 * @return {string}
 */
proto.proto.ChannelMarkData.FreezeData.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChannelMarkData.FreezeData} returns this
 */
proto.proto.ChannelMarkData.FreezeData.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChannelMarkData.MarkData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChannelMarkData.MarkData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChannelMarkData.MarkData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelMarkData.MarkData.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    controledid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChannelMarkData.MarkData}
 */
proto.proto.ChannelMarkData.MarkData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChannelMarkData.MarkData;
  return proto.proto.ChannelMarkData.MarkData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChannelMarkData.MarkData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChannelMarkData.MarkData}
 */
proto.proto.ChannelMarkData.MarkData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setControledid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChannelMarkData.MarkData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChannelMarkData.MarkData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChannelMarkData.MarkData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelMarkData.MarkData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getControledid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string controlId = 1;
 * @return {string}
 */
proto.proto.ChannelMarkData.MarkData.prototype.getControlid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChannelMarkData.MarkData} returns this
 */
proto.proto.ChannelMarkData.MarkData.prototype.setControlid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string controledId = 2;
 * @return {string}
 */
proto.proto.ChannelMarkData.MarkData.prototype.getControledid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChannelMarkData.MarkData} returns this
 */
proto.proto.ChannelMarkData.MarkData.prototype.setControledid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.proto);
